import interactiveElementSelector from '../interactiveElementSelector';

var getAllFocusableDescendents = function getAllFocusableDescendents(element) {
  return Array.from(element.querySelectorAll(interactiveElementSelector));
};

export default getAllFocusableDescendents;